import { useState } from 'react'
import { ImageOff } from 'lucide-react'
import { httpsMediaSrc } from '@/features/editor/lib/designUrl'

/**
 * Миниатюра картинки из замечания проверки (`image:<url>`). URL — данные сервера
 * (а по сути автора), в `src` только https. Картинки по ссылке может уже не быть:
 * автор заменил или удалил её после отказа, либо ссылка вела на внешний сайт, —
 * тогда вместо значка битой картинки браузера спокойная заглушка того же размера.
 */
const Thumb = ({ url }: { url: string }) => {
  const src = httpsMediaSrc(url)
  const [broken, setBroken] = useState(false)
  if (!src) return null
  return broken ? (
    <span className="flex size-12 shrink-0 items-center justify-center rounded-md bg-foreground/5 text-muted-foreground">
      <ImageOff className="size-5" />
    </span>
  ) : (
    <img
      src={src}
      alt=""
      onError={() => setBroken(true)}
      className="size-12 shrink-0 rounded-md object-cover"
    />
  )
}

/** Ключ — адрес: «сломано» относится к картинке по адресу, а не к месту в списке. */
export const ViolationThumb = ({ url }: { url: string }) => <Thumb key={url} url={url} />
